<template>
    <v-speed-dial
        v-show="isUserAuthenticated"
        v-model="sdfab"
        direction="bottom"
        top
        open-on-hover
        class="mt-n5 mr-n2"
    >
        <v-btn
            slot="activator"
            v-model="sdfab"
            fab
            color="primary"
            :class="{ 'fab-glow': userInfo.xocAuth }"
        >
            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <span class="text-h6 user-initials" v-on="on">{{
                        userInitials
                    }}</span>
                    <v-icon v-if="!userInitials.length" v-on="on">{{
                        icons.user
                    }}</v-icon>
                </template>
                <span class="text-caption">{{ userFullName }}</span>
            </v-tooltip>
        </v-btn>
        <v-tooltip v-for="(item, index) in items" :key="`ttip-${index}`" left>
            <template v-slot:activator="{ on }">
                <v-btn
                    :key="`btn-${item.name}`"
                    fab
                    small
                    light
                    color="primary"
                    v-on="on"
                    @click="item.action"
                >
                    <v-icon>{{ item.icon }}</v-icon>
                </v-btn>
            </template>
            <span class="text-caption">{{ item.tooltip }}</span>
        </v-tooltip>
    </v-speed-dial>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
    name: 'AppHeaderSpeedDial',
    data() {
        return {
            sdfab: false
        };
    },
    computed: {
        ...mapState('authUser', ['userInfo']),
        ...mapGetters('authUser', [
            'userInitials',
            'isUserAuthenticated',
            'isUserMemberOfMultipleVenues'
        ]),
        userFullName() {
            if (this.userInfo) {
                return `${this.userInfo.firstName} ${this.userInfo.lastName}`;
            }
            return '';
        },
        items() {
            let buttons = [
                {
                    name: 'userProfile',
                    icon: this.icons.user,
                    tooltip: 'User Profile',
                    action: this.onUserProfileClick
                },
                {
                    name: 'refreshProfile',
                    icon: this.icons.refresh,
                    tooltip: 'Refresh Profile',
                    action: this.onRefreshTokenClick
                },
                {
                    name: 'logout',
                    icon: this.icons.logout,
                    tooltip: 'Logout',
                    action: this.onLogoutClick
                }
            ];
            if (this.isUserMemberOfMultipleVenues) {
                buttons.splice(2, 0, {
                    name: 'switchVenue',
                    icon: this.icons.switchVenue,
                    tooltip: 'Switch Venue',
                    action: this.onSwitchVenueClick
                });
            }
            return buttons;
        }
    },
    methods: {
        ...mapActions('authUser', ['logout', 'refreshToken']),
        // ======================== Events ==============================
        async onLogoutClick() {
            await this.logout();
            this.$router.push({ name: 'loginPage' });
        },
        onUserProfileClick() {
            if (this.$router.currentRoute.name !== 'userProfilePage') {
                this.$router.push({ name: 'userProfilePage' });
            }
        },
        async onRefreshTokenClick() {
            try {
                await this.$store.dispatch('notifier/requestPending');
                await this.refreshToken();
                this.$router.go();
                await this.$store.dispatch('notifier/success', {
                    message: 'Profile was refreshed successfully.'
                });
            } catch (error) {
                console.log('Api call to [refreshToken] failed!');
                await this.$store.dispatch('notifier/error', {
                    message: 'Profile refresh has failed.'
                });
            }
        },
        onSwitchVenueClick() {
            this.$router.push({ name: 'venueSwitcherPage' });
        }
    }
};
</script>

<style>
.fab-glow {
    box-shadow: 0 0 10px var(--v-secondary-lighten4) !important;
}
</style>
